"use client";

import React from "react";
import useFavorites from "@/hooks/useFavorites";
import ProductCard from "@/components/ProductCard";
import StaticBreadcrumbClient from "@/app/components/StaticBreadcrumbClient";

export default function FavoritesPage() {
    const { favorites, isHydrated } = useFavorites();
    const hasFavorites = favorites.length > 0;

    return (
        <div className="site-container site-page pb-12">
            <div className="site-breadcrumb-wrap">
                <StaticBreadcrumbClient pageTitle="Сохранённое" />
            </div>
            <h1 className="text-2xl font-semibold md:text-3xl">Сохранённое</h1>

            {isHydrated ? (
                hasFavorites ? (
                    <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                        {favorites.map((item) => (
                            <ProductCard key={item.id} item={item} className="rounded-xl" />
                        ))}
                    </div>
                ) : (
                    <div className="mt-10 rounded-xl border border-dashed border-default-200 p-6 text-center text-sm text-default-500 md:p-10 md:text-base">
                        <p>У вас пока нет сохранённых позиций.</p>
                        <a
                            href="/shop"
                            className="mt-4 inline-flex items-center justify-center rounded-lg bg-primary px-5 py-2 text-sm font-semibold text-white transition hover:bg-primary/90"
                        >
                            Перейти в каталог
                        </a>
                    </div>
                )
            ) : (
                <div className="mt-10 h-32 rounded-xl border border-dashed border-default-200 bg-default-50" aria-hidden="true" />
            )}
        </div>
    );
}
